// docs: https://github.com/altostra/type-validations#readme
import { objectOf, maybe, arrayOf, recordOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

import type { CanvasItemsBlockingDeletionResult } from "./types";

export const isCanvasItemsBlockingDeletionResult = objectOf<CanvasItemsBlockingDeletionResult>({
  steps: objectOf({
    campaigns: maybe(arrayOf(string), true),
    workflows: maybe(arrayOf(string), true),
    workflow_steps: maybe(recordOf(arrayOf(string)), true),
    cards: maybe(arrayOf(string), true),
    segments: maybe(arrayOf(string), true),
  }),
  variations: objectOf({
    campaigns: maybe(arrayOf(string), true),
    workflows: maybe(arrayOf(string), true),
    workflow_steps: maybe(recordOf(arrayOf(string)), true),
    cards: maybe(arrayOf(string), true),
    segments: maybe(arrayOf(string), true),
  }),
});
